// frontend/src/api/auth.js
import api from './index';

export const login = async (email, password) => {
  try {
    const response = await api.post('/auth/login', { email, password });
    
    // Normaliza la respuesta
    return response.data.data ? response.data : { 
      data: response.data 
    };
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

export const quickAccess = async (role) => {
  try {
    const response = await api.post(`/auth/quick-access/${role}`);
    return response.data.data ? response.data : {
      data: response.data
    };
  } catch (error) {
    console.error('Quick access error:', error);
    throw error;
  }
};

export const verifyToken = async () => {
  try {
    const response = await api.get('/auth/verify');
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error al verificar sesión' };
  }
};

export const register = async (userData) => {
  try {
    const response = await api.post('/auth/register', userData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error al registrar usuario' };
  }
};

export const logout = async () => {
  try {
    const response = await api.post('/auth/logout');
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error al cerrar sesión' };
  }
};
